import { VIOLATIONS_TAB_LIST_AD_FILTER } from '../../../constants';

export const CUSTOM_INPUTS: Record<string, string> = {
  START: 'custom_risk_start_value',
  END: 'custom_risk_end_value',
} as const;

export const RISK_CUSTOM_LABEL_KEY = 'Custom';
export const DATE_CUSTOM_LABEL_KEY = 'Custom';

export const RANGE_BASED_FILTERS: string[] = [
  VIOLATIONS_TAB_LIST_AD_FILTER.VIOLATIONAGE.value,
  'RISKSCORE',
] as const;

export const DATE_BASED_FILTERS: string[] = [
  VIOLATIONS_TAB_LIST_AD_FILTER.MCEXPIRYDATE.value,
  VIOLATIONS_TAB_LIST_AD_FILTER.MCSTARTDATE.value,
  VIOLATIONS_TAB_LIST_AD_FILTER.MCENDDATE.value,
] as const;
